import React from 'react';
import { PhoneIcon, Shield, Zap, CheckCircle } from 'lucide-react';
import { Button } from '../components/Button';
import { MultiStepForm } from '../components/MultiStepForm';
import { WealthAccessSection } from '../components/WealthAccessSection';
import { ProcessSteps } from '../components/ProcessSteps';
import { StatCard } from '../components/StatCard';
import { FAQAccordion } from '../components/FAQAccordion';
import { CalculatorCTA } from '../components/CalculatorCTA';
import { GoogleReviews } from '../components/GoogleReviews';
export function HomePage() {
  return <main className="w-full" data-id="element-487">
      {/* Hero Section */}
      <section className="w-full bg-cream py-12 md:py-20 px-4" data-id="element-488">
        <div className="max-w-7xl mx-auto" data-id="element-489">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-8 items-center" data-id="element-490">
            {/* Left Column: Content */}
            <div className="text-center lg:text-left" data-id="element-491">
              <span className="inline-block px-4 py-2 font-medium rounded-full mb-6 border border-primary/20 text-[12px] font-[Poppins,_sans-serif] text-[#07493a] bg-[#07493a1a] pt-[4px] pb-[4px] pl-[18px] pr-[18px]" data-id="element-492">
                START TODAY
              </span>

              <h1 className="md:text-4xl lg:text-7xl font-serif text-gray-900 mb-6 font-[500] text-[72px]" data-id="element-493">
                Unlock the <span className="text-accent" data-id="element-494">Power</span> of Your
                Home's Equity
              </h1>

              <p className="text-lg md:text-xl text-gray-600 max-w-2xl mx-auto lg:mx-0 mb-8 leading-relaxed" data-id="element-495">
                Join thousands of Canadian homeowners who have accessed their
                equity to fund their dreams. No credit checks. No age
                restrictions. Funding in as little as 48 hours.
              </p>

              <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-4 mb-12" data-id="element-496">
                <Button variant="primary" size="lg" icon href="#form" data-id="element-497">
                  Find Out How Much You Can Borrow
                </Button>
                <Button variant="outline" size="lg" href="tel:+16476679957" data-id="element-498">
                  <PhoneIcon className="mr-2 h-5 w-5" aria-hidden="true" data-id="element-499" />
                  Call Us Now
                </Button>
              </div>

              {/* Trust Indicators - moved from separate section */}
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-3xl mx-auto lg:mx-0" data-id="element-500">
                <div className="flex items-center space-x-3" data-id="element-501">
                  <div className="w-10 h-10 bg-[#07493a1a] rounded-lg flex items-center justify-center flex-shrink-0" data-id="element-502">
                    <Shield className="w-5 h-5 text-[#07493a]" data-id="element-503" />
                  </div>
                  <div data-id="element-504">
                    <h3 className="text-base font-semibold text-gray-900" data-id="element-505">
                      FSRA Licensed
                    </h3>
                    <p className="text-sm text-gray-500" data-id="element-506">#12755</p>
                  </div>
                </div>

                <div className="flex items-center space-x-3" data-id="element-507">
                  <div className="w-10 h-10 bg-[#07493a1a] rounded-lg flex items-center justify-center flex-shrink-0" data-id="element-508">
                    <Zap className="w-5 h-5 text-[#07493a]" data-id="element-509" />
                  </div>
                  <div data-id="element-510">
                    <h3 className="text-base font-semibold text-gray-900" data-id="element-511">
                      48hr Funding
                    </h3>
                    <p className="text-sm text-gray-500" data-id="element-512">Quick access</p>
                  </div>
                </div>

                <div className="flex items-center space-x-3" data-id="element-513">
                  <div className="w-10 h-10 bg-[#07493a1a] rounded-lg flex items-center justify-center flex-shrink-0" data-id="element-514">
                    <CheckCircle className="w-5 h-5 text-[#07493a]" data-id="element-515" />
                  </div>
                  <div data-id="element-516">
                    <h3 className="text-base font-semibold text-gray-900" data-id="element-517">
                      No Credit Check
                    </h3>
                    <p className="text-sm text-gray-500" data-id="element-518">Equity-based</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Right Column: Form */}
            <div className="w-full max-w-xl mx-auto lg:ml-auto" data-id="element-519">
              <MultiStepForm data-id="element-520" />
            </div>
          </div>
        </div>
      </section>

      {/* Wealth Access Section */}
      <WealthAccessSection data-id="element-521" />

      {/* Process Steps */}
      <ProcessSteps data-id="element-522" />

      {/* Calculator CTA Section */}
      <CalculatorCTA data-id="element-523" />

      {/* Google Reviews Section */}
      <GoogleReviews data-id="element-524" />

      {/* FAQ Section */}
      <FAQAccordion data-id="element-525" />
    </main>;
}